import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-disclaimer',
  templateUrl: '../../../assets/html/disclaimer.html',
  styleUrls: ['./disclaimer.component.css']
})
export class DisclaimerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    var t = $('[data-parallax="scroll"]').data('imageSrc');
    $('[data-parallax="scroll"]').parallax({imageSrc: t});
  }

}
